import React from 'react'
import { cn } from '../../lib/utils'

interface GridHeaderProps {
  horizonStart: number
  horizonEnd: number
}

const CURRENT_YEAR = new Date().getFullYear()

export const GridHeader = React.memo(function GridHeader({
  horizonStart,
  horizonEnd,
}: GridHeaderProps) {
  const years: number[] = []
  for (let y = horizonStart; y <= horizonEnd; y++) {
    years.push(y)
  }

  return (
    <thead>
      <tr>
        {/* Sticky first column: empty label cell */}
        <th
          className="sticky left-0 z-20 bg-background border-b border-r border-border w-80 min-w-80 px-3 py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide"
        />
        {/* Year columns */}
        {years.map((year) => {
          const isCurrent = year === CURRENT_YEAR
          return (
            <th
              key={year}
              className={cn(
                'min-w-32 px-2 py-2 text-center text-xs font-medium text-muted-foreground uppercase tracking-wide border-b border-border',
                isCurrent && 'border-x-2 border-x-primary font-bold text-primary bg-primary/5'
              )}
            >
              {year}
              {isCurrent && (
                <span className="ml-1 text-primary">•</span>
              )}
            </th>
          )
        })}
      </tr>
    </thead>
  )
})
